export const TenData = () => {
  return (
    <div>
     <p> Kindly check the request which you are sending to the Payment Gateway with below conditions:</p>
     <p>1. Allthe parameters are mandatory in the request.</p>
     <p>2. Values under Mandatory Parameters should be pipe separated, for example :</p>
     <p>Txn_Details:paygate|201701240003|96692adf|1600|ARE|AED|SALE| http://localhost /safexpay/Response.php |http://localhost/safexpay/Response.php|WEB</p>
     <p>3. Check with the parameters which should be send blank pipe separated, for example:</p>
     <p>Decrypted Pg_details: |||</p>
     <p>Decrypted Cust_details: ||9999555666||Y</p>
     <p>Decrypted Bill_details: || ||</p>
     <p>Decrypted Ship_details: ||||||</p>
     <p>Decrypted Item_details: ||</p>
     <p>Decrypted Card_details: |</p>
     <p>Decrypted Other_details: ||||</p>
    </div>
  );
};

export const FourData = () => {
  return (
    <div>
      <p> Kindly check Merchant ID and Post URL, If Merchant Id is Test then Post URL is also to be Test Server.</p>

      <p>Test Post URL :
        <a href="https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage">https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage  </a>
      </p>
      
      <p>Production Post URL :
        <a href="https://pg.safexpay.ae/agcore/paymentProcessing">https://pg.safexpay.ae/agcore/paymentProcessing</a>
      </p>

      
    </div>
  );
};

export const NineData = () => {
  return (
    <div>
      <p>  2 ways to refund the transactions :</p>
      <p>
        1. You can initiate the refund (Partial or Full) from the “Merchant
        Portal under the Transaction ” Enter the OrderNumber and click on Refund
        (Partial or Refund)
      </p>

      <p>
        2. You need to implement “Refund API” in your Server, which is very
        important and Consider as Mandatory"
      </p>
    </div>
  );
};


export const SevenData = () => {
  return (
    <div>
      <p> 2 Waysto check the transaction status at your end :</p>
      <p>
      1. If you want to check the status of an order that has been placed, you can look it up in the “Merchant Portal under Transaction ”. This allows you to enter an order number and view the status. If you donot know the order number, please ask the customer who placed the order for this information. 
      </p>

      <p>
        2. You need to implement “Status Check API” in your Server, which is very important and Consider asMandatory.
      </p>
    </div>
  );
};



export const TwelveData = () => {
  return (
    <div>
      <p></p>
      <p>
      1. If Integration Type “Merchant Hosted”,then it is mandatory. 
      </p>

      <p>
      2. If Integration Type “Aggregator Hosted”,then it is mandatory.
      </p>

      <p>
      3. If Integration Type “Aggregator Hosted with Paymode”,then only Paymode is mandatory.
      </p>
    </div>
  );
};





const FAQsdata = [
  {
    id: 1,
    question: "1. Is Safexpay safe?",
    answer:
      " Safexpay is a Safe payment gateway as we are PCI DCC compliance certified, which indicates that it takescare of securing your data appropriately",
  },
  {
    id: 2,
    question: "2. Which Credit cards does Safexpay accept?",
    answer:
      " Safexpay can handle customer purchases made through MasterCard, Visa, American Express, Eze Click, Diners Club and JCB credit cards.",
  },
  {
    id: 3,
    question: "3. What are all types of Payment accepted in Safexpay?",
    answer:
      "At present Safexpay accepts Debit Cards, ATM cum Debit Cards, Net Banking Payments, Cash Cards, Digital and Mobile Wallets, and Mobile Payments.",
  },
  {
    id: 4,
    question:
      '4. When clicking on a Checkout, an error message appears which says: " Invalid Merchant ID”. There is a problem in the request Web page address."? ',
    answer: <FourData/>
      

    
    
  },
  {
    id: 5,
    question:
      '5. When clicking on a Checkout, an error message appears which says: " Invalid Merchant ID”. There is a problem in the request Web page address."?',
    answer:
      " Order Number which you send in the request for each transaction should be Unique.",
  },
  {
    id: 6,
    question:
      '6. When clicking on a Checkout, an error message appears which says: "Invalid Referral URL”?',
    answer:
      " You need to confirm with Safexpay providing Merchant ID, whether your Domain URL is whitelisted/added in our Server against that Merchant ID.",
  },
  {
    id: 7,
    question: "7. How can I check the Status of an Order?",
    answer: <SevenData/>
  },

  {
    id: 8,
    question:
      '8. When clicking on a Checkout, an error message appears which says: "Merchant Is an Inactive”. There is a problem in the request"?',
    answer:
      "  Kindly check with the Safexpay Team,statusforthe Merchant ID which you send in the Request.",
  },
  {
    id: 9,
    question: "9. How to Refund the Successful Transaction ?",
    answer: <NineData />
  },
  {
    id: 10,
    question:
      '10. When clicking on a Checkout, an error message appears which says: "Error While Processing your request"?',
    answer: <TenData/>
  },
  {
    id: 11,
    question:
      '11. When clicking on a Checkout, an error message appears which says: "Invalid County or Currency code"?',
    answer:
      " Please check with Country code (3 letters) and currency code (2 letters) mapped for your Merchant account, for example:Country code is ARE, Currency code should be AED.",
  },
  {
    id: 12,
    question:
      "12. Is Parameter PG_Detailsis mandatory in the Transaction Request?",
    answer: <TwelveData/>
  },
  {
    id: 13,
    question:
      '13. When clicking on a Checkout, an error message appears which says: "Invalid Encryption”?',
    answer:
      " Please check with the Encryption key which you are using to encrypt the request and check thePost URL, if the Merchant ID is UAT then Payment URL should be belongs to test server and similarly to Production server.",
  },
];
export default FAQsdata;
